const faqs = [
  {
    q: '青柠影视真的完全免费吗？需要注册吗？',
    a: '是的，青柠影视完全免费，无需注册即可直接观看所有内容。我们通过优化技术架构和运营效率来控制成本，从而让每一位用户都能免费享受高清追剧体验。未来即使推出会员增值服务，核心观影功能也将永久对所有人免费开放。',
  },
  {
    q: '视频画质怎么样？支持哪些清晰度？',
    a: '青柠影视全站支持 1080P 高清画质，部分热门内容已上线 4K 版本。我们采用先进的视频编码技术，在保证清晰度的同时优化带宽消耗，让你即使在普通网络环境下也能流畅观看高清内容。播放器支持画质手动切换，你可以根据网络情况自由选择。',
  },
  {
    q: '资源更新速度如何？新剧什么时候能看？',
    a: '我们的内容团队 7×24 小时值班，热门剧集通常播出后数小时内即上线，电影资源也在院线下映后第一时间更新。青柠影视建立了高效的资源同步系统，确保你总能第一时间看到最新内容。如遇到更新延迟，欢迎通过投稿合作渠道提醒我们。',
  },
  {
    q: '在手机上能看吗？支持哪些设备？',
    a: '当然可以！青柠影视网页版已完美适配手机、平板、电脑等所有主流设备，你只需要在浏览器中打开即可。移动端 App 正在开发中，上线后将提供离线缓存、夜间模式等更丰富的功能。当前建议使用 Chrome、Safari 浏览器获得最佳体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于青柠影视的使用问题，这里都能找到答案
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-white text-xs font-bold mt-0.5">
                  Q
                </span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}